import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "ion-margin-bottom" }, "Choose a way to create new visitors", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Add a guest list from an .xls or .xlsx file.", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Manually add visitors to your event.", -1)
const _hoisted_5 = { class: "ion-text-center ion-padding" }

import { cloudUpload, personAdd, arrowBack } from "ionicons/icons";
import {
  IonContent,
  IonPage,
  IonFooter,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardSubtitle,
  IonIcon,
  IonCardContent,
  onIonViewWillEnter,
} from "@ionic/vue";
import { useRoute } from "vue-router";

import { useContextStore } from "@/stores/context";
import { useWindowWidth } from "@/composition/window";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddVisitors',
  setup(__props) {

const { isMobile } = useWindowWidth();
const contextStore = useContextStore();
const route = useRoute();
const event_id = parseInt(route.params.event_id as string, 10);

onIonViewWillEnter(async () => {
  contextStore.getEvent(event_id);
});

return (_ctx: any,_cache: any) => {
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "flex-desktop",
              style: _normalizeStyle([{"align-items":"center"}, _unref(isMobile) ? '' : 'position: relative; left: -75px;'])
            }, [
              (!_unref(isMobile))
                ? (_openBlock(), _createBlock(_component_ion_fab_button, {
                    key: 0,
                    color: "primary",
                    style: {"margin-right":"20px"},
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), { icon: _unref(arrowBack) }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _hoisted_2
            ], 4),
            _createVNode(_unref(IonCard), {
              "router-link": `/event/${_unref(contextStore).event.id}/import-visitors`
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCardHeader), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCardSubtitle), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonIcon), { icon: _unref(cloudUpload) }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonCardTitle), null, {
                      default: _withCtx(() => [
                        _createTextVNode(" Import spreadsheet ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonCardContent), null, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["router-link"]),
            _createVNode(_unref(IonCard), {
              "router-link": `/event/${_unref(contextStore).event.id}/new-visitor`
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCardHeader), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCardSubtitle), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonIcon), { icon: _unref(personAdd) }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonCardTitle), null, {
                      default: _withCtx(() => [
                        _createTextVNode(" Add individual visitors ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonCardContent), null, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["router-link"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(IonFooter), null, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_5, [
            _createTextVNode(" This event has a capacity for "),
            _createElementVNode("b", null, _toDisplayString(_unref(contextStore).event.capacity) + " visitors", 1),
            _createTextVNode(". ")
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})